import {Outlet} from 'react-router-dom'

import SignInContainer from '../components/auth/SignInContainer'

export default [
  {
    path: 'auth',
    element: <Outlet />,
    children: [
      {
        path: 'sign-in',
        element: <SignInContainer />
      }
    ]
  }
]
